<template>
  <div
    id="formulator__output"
    class="formulator__output"
  >
    <!-- <div v-if="!isCoagraWeb" class="formulator__output-header"></div> -->
    <hr class="output-separator output-separator--top">
    <info />
    <hr class="output-separator">
    <div class="l-output-information">
      <nutritional-information />
      <hr class="output-separator">
      <ingredient-content />
      <div v-if="selectedTab === 'high-precision'">
        <hr class="output-separator">
        <goals />
      </div>
      <div v-if="showWeightRequirement">
        <hr class="output-separator">
        <weight-required />
      </div>
    </div>
    <hr class="output-separator">
    <div class="output__button">
      <button
        class="formulator__button"
        @click="checkIfAuth"
        :disabled="!updated"
      >
        Continuar
      </button>
    </div>
  </div>
</template>
<script>
import store from '../store';
import helper from '../helpers';
import baggedOrder from './bagged-order';
import info from './output/info.vue';
import nutritionalInformation from './output/nutritional-information.vue';
import ingredientContent from './output/ingredient-content.vue';
import WeightRequired from './output/weight-required.vue';
import goals from './output/goals.vue';

export default {
  store,
  components: {
    info,
    nutritionalInformation,
    ingredientContent,
    WeightRequired,
    goals,
  },
  methods: {
    checkIfAuth() {
      if (this.selectedTab === 'ingredient' && this.baggedPowderDensityBlocked()) {
        this.$modal.show('grain-limit-warning-modal', {
          title: 'Aviso',
          messages: [baggedOrder.BAGGED_POWDER_DENSITY_MESSAGE],
        });

        return;
      }

      const messages = [...this.grainLimitMessages(), ...this.categoryLimitMessages()];

      if (messages.length > 0) {
        this.$modal.show('grain-limit-warning-modal', {
          title: 'Aviso',
          messages,
        });

        return;
      }

      if (this.loggedIn) {
        this.goToNewOrder();
      } else {
        this.$store.state.nextPath = this.newOrderPath;
        this.showAuthModal();
      }
    },
    // Restricción de fórmulas altas en granos (misma regla que producción):
    // - Si supera el límite de granos y faltan minerales, se exige un mínimo
    //   de minerales Y de aglomerante.
    // - Si ya tiene minerales suficientes pero falta aglomerante, solo se
    //   exige el aglomerante.
    grainLimitMessages() {
      if (this.$store.state.recipe.finishing.form.value === 'powder') return [];

      const limits = this.$store.state.settingsLimits;
      const messages = [];
      const grainPercentage = this.calculateCategoriesPercentage(['grain']);
      const binderPercentage = this.calculateCategoriesPercentage(['binder']);
      // El mínimo de minerales considera las sales minerales y también los
      // ingredientes de la categoría Aditivos (no el Aglomerante, que tiene
      // su propio mínimo).
      const mineralPercentage = this.calculateCategoriesPercentage(['salt_alisur', 'additive']);

      if (grainPercentage > limits.grain_limit_without_binder && mineralPercentage < limits.min_salt_with_binder) {
        messages.push(`Para obtener el mejor resultado, en fórmulas con más de \
${limits.grain_limit_without_binder}% de granos debes agregar al menos un \
${limits.min_salt_with_binder}% de minerales y un \
${limits.min_binder_percentage}% de Aglomerante.`);
      } else if (
        grainPercentage > limits.grain_limit_without_binder && binderPercentage < limits.min_binder_percentage
      ) {
        messages.push(`Para obtener el mejor resultado, en fórmulas con más de \
${limits.grain_limit_without_binder}% de granos debes agregar al menos un \
${limits.min_binder_percentage}% de Aglomerante.`);
      }

      return messages;
    },
    // Límites por categoría definidos en Ajustes (0 = sin límite). Aplican a
    // todos los formuladores, pero SOLO a productos peletizados (no a los
    // harinados ni otras presentaciones).
    categoryLimitMessages() {
      const form = this.$store.state.recipe.finishing.form.value;
      if (!this.$store.getters.pelletForms.includes(form)) return [];

      const limits = this.$store.state.settingsLimits;
      const messages = [];
      const fibrousPercentage = this.calculateCategoriesPercentage(['floured']);
      const proteinPercentage = this.calculateCategoriesPercentage(['protein']);

      if (limits.fibrous_ingredients_limit > 0 && fibrousPercentage > limits.fibrous_ingredients_limit) {
        messages.push(`Para obtener el mejor resultado, la fórmula no puede superar el \
${limits.fibrous_ingredients_limit}% de ingredientes altos en fibra`);
      }
      if (limits.protein_ingredients_limit > 0 && proteinPercentage > limits.protein_ingredients_limit) {
        messages.push(`Para obtener el mejor resultado, la fórmula no puede superar el \
${limits.protein_ingredients_limit}% de ingredientes protéicos`);
      }

      return messages;
    },
    baggedPowderDensityBlocked() {
      const formState = this.$store.state.recipe.finishing.form;
      const packagingState = this.$store.state.recipe.finishing.packaging;
      const form = typeof formState === 'string' ? formState : formState?.value;
      const packaging = typeof packagingState === 'string' ? packagingState : packagingState?.value;

      return baggedOrder.baggedPowderDensityBlocked({
        form,
        packaging,
        minDensity: this.$store.state.settingsLimits.min_bagged_powder_density,
        proportions: this.$store.state.recipe.ingredientsProportion,
        ingredientsByName: this.$store.state.ingredients,
      });
    },
    calculateCategoriesPercentage(categories) {
      const ingredientsProportion = this.$store.state.recipe.ingredientsProportion;
      const ingredients = this.$store.state.ingredients;

      return Object.keys(ingredientsProportion).reduce((total, ingredientName) => {
        const ingredient = ingredients[ingredientName];
        const percentage = parseFloat(ingredientsProportion[ingredientName]) || 0;

        if (ingredient && categories.includes(ingredient.category)) {
          return total + percentage;
        }

        return total;
      }, 0);
    },
    showAuthModal() {
      this.$modal.show('auth-modal');
    },
    goToNewOrder() {
      window.location.href = this.newOrderPath;
    },
  },
  computed: {
    updated() {
      return this.$store.state.recipe.updated;
    },
    dailyWeightRequirement() {
      return this.$store.state.recipe.dailyWeightRequirement;
    },
    showWeightRequirement() {
      return this.selectedTab === 'high-precision';
    },
    selectedTab() {
      return this.$store.state.formulator.selectedTab;
    },
    dairyInfo() {
      return this.$store.state.formulator.dairyInfo;
    },
    newOrderPath() {
      let formulatorParams = helper.serializeQuery(this.$store.getters.params, 'ingredients_proportion');
      formulatorParams += `&${helper.serializeQuery(this.$store.state.recipe.nutritionalInfo, 'nutritional_info')}`;
      formulatorParams += `&form=${this.$store.state.recipe.finishing.form.value}`;
      formulatorParams += `&packaging=${this.$store.state.recipe.finishing.packaging.value}`;
      const totalSackWeight = this.$store.state.recipe.finishing.totalSackWeight;
      if (totalSackWeight) formulatorParams += `&total_sack_weight=${totalSackWeight}`;
      const via = this.$store.state.via;
      formulatorParams += `&via=${via}`;

      if (this.$store.state.order.isColunWeb) {
        formulatorParams += '&tenant=colun';
      } else if (this.$store.state.order.isCoagraWeb) {
        formulatorParams += '&tenant=coagra';
      }

      return helper.appendModifyOrderId(`/order/new?${formulatorParams}`);
    },
    loggedIn() {
      return this.$store.state.loggedIn;
    },
    isCoagraWeb() {
      return this.$store.state.order.isCoagraWeb;
    },
  },
};
</script>
